import type React from "react";
import { useTranslation } from "react-i18next";
import { FloatingTooltip } from "../../../common/components/Tooltip/FloatingTooltip";
import { IoMdInformationCircleOutline } from "react-icons/io";

interface SkipIntakeButtonProps {
  canSkip: boolean;
  reason: string | null;
  isSubmitting: boolean;
  onClick: () => void;
}

const SkipIntakeButton: React.FC<SkipIntakeButtonProps> = ({
  canSkip,
  reason,
  isSubmitting,
  onClick,
}) => {
  const { t } = useTranslation();
  const disabled = !canSkip || isSubmitting;
  const button = (
    <button
      onClick={onClick}
      disabled={disabled}
      className="btn-primary-outline text-sm"
      data-tour="scenaria-workbench-skip-intake"
    >
      {t("pages.chat.skipIntakeGenerate")}
    </button>
  );
  return (
    <div className="flex flex-col items-center gap-2 my-2">
      <div className="flex items-center gap-1.5 text-xs text-gray-500 italic">
        <IoMdInformationCircleOutline className="shrink-0" />
        <span>{t("pages.chat.skipIntakeHint")}</span>
      </div>
      {disabled && reason ? (
        <FloatingTooltip content={t(reason)} wrap>
          {button}
        </FloatingTooltip>
      ) : (
        button
      )}
    </div>
  );
};

export default SkipIntakeButton;
